import {
  throwSubtypeNotRegistered2cr459177l268 as throwSubtypeNotRegistered,
  throwSubtypeNotRegistered343gt7v9eqwun as throwSubtypeNotRegistered_0,
  AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer,
} from './internal/AbstractPolymorphicSerializer.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3qslfm3vqg6y3 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import {
  OPEN_getInstance2yamxaa1a8hlr as OPEN_getInstance,
  CONTEXTUAL_getInstance2j6ylx8hc4yv2 as CONTEXTUAL_getInstance,
} from './descriptors/SerialKinds.mjs';
import { StringCompanionObject_instance1v0ht40fz3tq0 as StringCompanionObject_instance } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { serializer1x79l67jvwntn as serializer } from './builtins/BuiltinSerializers.mjs';
import { buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor } from './descriptors/SerialDescriptors.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { withContext3ge61vpog00ae as withContext } from './descriptors/ContextAware.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function findPolymorphicSerializer(_this__u8e3s4, decoder, klassName) {
  var tmp0_elvis_lhs = _this__u8e3s4.p1m(decoder, klassName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered(klassName, _this__u8e3s4.q1m());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function findPolymorphicSerializer_0(_this__u8e3s4, encoder, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.r1m(encoder, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered_0(getKClassFromExpression(value), _this__u8e3s4.q1m());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function PolymorphicSerializer$_get_descriptor_$ref_8tw9if() {
  return (p0) => p0.m1m();
}
var PolymorphicSerializerClass;
function PolymorphicSerializer() {
  if (PolymorphicSerializerClass === VOID) {
    class $ extends AbstractPolymorphicSerializer() {
      static v1m(baseClass) {
        var $this = this.w1m();
        $this.s1m_1 = baseClass;
        $this.t1m_1 = emptyList();
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.u1m_1 = lazy(tmp_0, () => {
          var tmp = OPEN_getInstance();
          return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], ($this$buildSerialDescriptor) => {
            $this$buildSerialDescriptor.f1n('type', serializer(StringCompanionObject_instance).m1m());
            $this$buildSerialDescriptor.f1n('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + $this.s1m_1.j1() + '>', CONTEXTUAL_getInstance(), []));
            $this$buildSerialDescriptor.z1m_1 = $this.t1m_1;
            return Unit_instance;
          }), $this.s1m_1);
        });
        return $this;
      }
      q1m() {
        return this.s1m_1;
      }
      m1m() {
        var tmp0 = this.u1m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, PolymorphicSerializer$_get_descriptor_$ref_8tw9if(), null);
        return tmp0.n3();
      }
      toString() {
        return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.s1m_1) + ')';
      }
    }
    initMetadataForClass($, 'PolymorphicSerializer');
    PolymorphicSerializerClass = $;
  }
  return PolymorphicSerializerClass;
}
//region block: exports
export {
  PolymorphicSerializer as PolymorphicSerializer3p3fzpdobi8hh,
  findPolymorphicSerializer as findPolymorphicSerializer1nm87hvemahcj,
  findPolymorphicSerializer_0 as findPolymorphicSerializerk638ixyjovk5,
};
//endregion

//# sourceMappingURL=PolymorphicSerializer.mjs.map
